import styled from "styled-components";
import { RATypography, RAButtonPrimary, RARadioButton, RACheckbox } from "@/components/customs";
import { Row, Col, Divider } from "antd";
import { initFormAddAlertEmptyLegs } from "@/utils/initializing";
import { SvgDirection, SvgLocation } from "@/assets/icons";
import { RAInputSearchAirport } from "@/components/atoms";
import { InputAlertDepartureWindow } from "./InputAlertDepartureWindow";

export function FormUpdateAlert({ data = initFormAddAlertEmptyLegs, onChange, onSubmitEditAlert }) {
	const { type, type_airport = [] } = data;

	const _renderHeader = () => {
		return (
			<Row>
				<Col md={24}>
					<WrapperContent>
						<RATypography variant="h3">Edit Alert</RATypography>
					</WrapperContent>
				</Col>
			</Row>
		);
	};

	const _renderDepartureAirport = () => {
		if (data.type === "ROUTE") {
			return (
				<Row gutter={[20, 20]} align="middle" style={{ marginTop: "20px" }}>
					<Col span={24}>
						<RAInputSearchAirport
							data-testid="EmptyLegAlert_departureAirport"
							title="Departure"
							prefix={<SvgDirection color="#595959" />}
							placeholder="Select departure airport"
							disabled={true}
							value={data?.from_airport}
							onSelect={(value) => {
								onChange({
									...data,
									from_airport: value,
								});
							}}
						/>
					</Col>
					<Col span={24}>
						<RAInputSearchAirport
							data-testid="EmptyLegAlert_arrivalAirport"
							title="Arrival"
							prefix={<SvgLocation color="#595959" />}
							placeholder="Select arrival airport"
							disabled={true}
							value={data?.to_airport}
							onSelect={(value) => {
								onChange({
									...data,
									to_airport: value,
								});
							}}
						/>
					</Col>
				</Row>
			);
		} else if (type === "AIRPORT") {
			return (
				<Row gutter={[20, 20]} align="middle" style={{ marginTop: "20px" }}>
					<Col span={24}>
						<RAInputSearchAirport
							data-testid="EmptyLegAlert_airport"
							title="Airport"
							prefix={<SvgDirection color="#595959" />}
							placeholder="Select airport"
							disabled={true}
							value={data?.airport}
							onSelect={(value) => {
								onChange({
									...data,
									airport: value,
								});
							}}
						/>
					</Col>
					<Col span={24}>
						<RATypography color="#595959" variant="sub-heading4" bottom={8}>
							Departure or Arrival
						</RATypography>
						<Row gutter={[40, 12]}>
							<Col>
								<RACheckbox
									data-testid="EmptyLegAlert_departureCheckbox"
									checked={type_airport.includes("DEPARTURE")}
									title="Departure"
									onChange={() => {
										let newTypeAirport = [...type_airport];
										let indexTypeAirport = newTypeAirport.findIndex((v) => v === "DEPARTURE");
										if (indexTypeAirport > -1) {
											newTypeAirport.splice(indexTypeAirport, 1);
										} else {
											newTypeAirport.push("DEPARTURE");
										}
										onChange({
											...data,
											type_airport: newTypeAirport,
										});
									}}
								/>
							</Col>
							<Col>
								<RACheckbox
									data-testid="EmptyLegAlert_arrivalCheckbox"
									checked={type_airport.includes("ARRIVAL")}
									title="Arrival"
									onChange={() => {
										let newTypeAirport = [...type_airport];
										let indexTypeAirport = newTypeAirport.findIndex((v) => v === "ARRIVAL");
										if (indexTypeAirport > -1) {
											newTypeAirport.splice(indexTypeAirport, 1);
										} else {
											newTypeAirport.push("ARRIVAL");
										}
										onChange({
											...data,
											type_airport: newTypeAirport,
										});
									}}
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			);
		}
	};

	const _renderAlertInfo = () => {
		return (
			<div>
				{_renderDepartureAirport()}
				<Row gutter={[20, 20]} align="middle" style={{ marginTop: "20px" }}>
					<Col span={24}>
						<InputAlertDepartureWindow
							from_datetime={data.from_datetime}
							to_datetime={data.to_datetime}
							onChange={(values) => {
								onChange({
									...data,
									...values,
								});
							}}
						/>
					</Col>
				</Row>
			</div>
		);
	};

	return (
		<ContainerRequestFlight data-testid="AddAlertModal_content">
			{_renderHeader()}
			<Divider />
			{_renderAlertInfo()}
			<Row justify="center" align="middle" style={{ marginTop: "40px" }}>
				<RAButtonPrimary
					data-testid="EmptyLegAlert_submitBtn"
					title="SUBMIT"
					onClick={() => onSubmitEditAlert()}
					width="160px"
				/>
			</Row>
		</ContainerRequestFlight>
	);
}

const ButtonRequestOption = ({ active, onChange, title = "" }) => (
	<ButtonOption align="middle" justify="center" onClick={onChange} active={active} gutter={{ xs: 8, md: 20 }}>
		<Col>
			<RARadioButton checked={active} title={title} onChange={() => {}} />
		</Col>
	</ButtonOption>
);

const ContainerRequestFlight = styled.div`
	width: "100%";
	padding: 30px;
	@media (max-width: 576px) {
		padding: 0;
	}
`;
const WrapperContent = styled.div`
	padding: 0px 20px;
	flex-direction: column;
	align-items: center;
	border-left: 2px solid #ffb11a;
`;
const ButtonOption = styled(Row)`
	padding: 12px 20px;
	flex-wrap: nowrap;
	border: 1px solid #e9e8e8;
	border-radius: 8px;
	cursor: pointer;
	${({ active }) =>
		active &&
		`
        border: 1px solid #ffc34d;
    `}
`;
